<template>
    <div class="step lead-name">
        <AdvSubTitle>{{ $t("common:signLog.adv.leadnameSubtitle") }}</AdvSubTitle>
        <AdvTitle class="mt-8" :class="[isMobileSize ? 'mb-20' : 'mb-32']"
        >{{ $t("common:signLog.adv.leadnameTitle") }}</AdvTitle
        >
        <AdvInput
            ref="input"
            v-bind="inputConfig"
            @changeValue="changeValue"
        ></AdvInput>
        <AdvBtn
            class="mb-30"
            :class="[isMobileSize ? 'mt-10' : 'mt-24']"
            @click="handleNext"
        >{{ $t("common:signLog.adv.leadnameBtn") }}</AdvBtn
        >
        <AdvDescript class="bt pb-30"
        >{{ $t("common:signLog.adv.leadnameDesc",{counts:params.counts}) }}</AdvDescript
        >
        <AdvProgress
            class="pt-34 btop"
            :value="progress()"
            v-if="!isMobileSize"
        ></AdvProgress>
    </div>
</template>
<script>
import register from '../../register.js';
import AdvBtn from './components/btn.vue';
import AdvDescript from './components/descript.vue';
import AdvInput from './components/input.vue';
import AdvProgress from './components/progress.vue';
import AdvSubTitle from './components/subTitle.vue';
import AdvTitle from './components/title.vue';
import common from './common';
export default {
    mixins: [register, common],
    data: function() {
        return {
            inputConfig: {
                placeholder: `Full Name`,
                maxLength: 30,
                validator: this.validateName
            },
            value: ''
        };
    },
    inject: ['progress', 'next', 'params'],
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
    },
    methods: {
        changeValue(v) {
            this.value = v;
        },
        async handleNext() {
            let pass = await this.$refs.input._validate();
            if (pass) {
                this.next({ fullname: this.value });
            }
        },
        async validateName(val) {
            const len = val.trim().length;
            let pass = len <= 30 && len > 0;
            return pass
                ? Promise.resolve(pass)
                : Promise.reject({
                    errorInfo: this.$t('common:validate.fieldRequired')
                });
        }
    },
    components: {
        AdvBtn,
        AdvDescript,
        AdvInput,
        AdvProgress,
        AdvSubTitle,
        AdvTitle
    }
};
</script>
<style lang="scss"></style>
